import "../../../index.css";
import React, { useContext, useState, useEffect } from 'react';
import * as microsoftTeams from "@microsoft/teams-js";

export function ChangeCalendar() {    
    const [calendarUrl, setCalendarUrl] = useState("");

    const reactFunctionEndpoint= process.env.REACT_APP_FUNCTION_ENDPOINT;
    const [accesstoken, setToken]= useState(null);
    const viewCalendarUrl = `${reactFunctionEndpoint}/api/getSettings?type=changecalendarurl`;

     useEffect(()=> {
            const fetchToken = async() =>{
            try{
                await microsoftTeams.app.initialize();
                const ssoToken =await microsoftTeams.authentication.getAuthToken();
                setToken(ssoToken);
            } catch (err){
                console.err("Token check error: ", err);
            }
            };
            fetchToken();
        },[]);
    

    useEffect(() => {
            const fetchData = async () => {
                try {
                    const response = await fetch(viewCalendarUrl,
                            {
                                method: "GET",
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: `Bearer ${accesstoken}`,
                                },
                            } 
                        );
                    const resp_json = await response.json();
    
                    setCalendarUrl(resp_json.urlPath);
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            };
            fetchData();
        }, [accesstoken]);

    return (
        <div className="tabHeader">

            <p>Calendar of all changes and maintenance periods happening in IT environment. </p>
            {calendarUrl ? (            
                <a className="change_calendar" href={calendarUrl} target="_blank" rel="noopener noreferrer">
                    View Change Calendar
                </a>
            ) : (
                <p style={{ color: 'red' }}>{"Please wait..."}</p>
            )}
        </div>
    );
}
